import { render } from "./MarksAvailable.vue?vue&type=template&id=2eb735ba"
import script from "./MarksAvailable.vue?vue&type=script&lang=js"
export * from "./MarksAvailable.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/front/sevist-vue3-front-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__